// extracted by mini-css-extract-plugin
export var bodySections = "_dm-8";
export var gray = "_dm-7";
export var green = "_dm-4";
export var iconContainer = "_dm-9";
export var iconWidgetContainer = "_dm-1";
export var phoneIcon = "_dm-2";
export var red = "_dm-5";
export var statusDot = "_dm-3";
export var widgetContainer = "_dm-0";
export var yellow = "_dm-6";